import { CartActions } from './../constants/actionType'
import * as chat from './../service/aimsChat';
const initialState = {
    cartHeader: [],
    cartData: [],
    cartResponse: [],
    isProfileCartOpen: false,
    cartOfferToggle: {
        isAutopayOffer: true,
        isSpecialOffer: true,
        isSpecialOneTimeOffer: true
    },
    splitBillTab: 0,
    cartOrderDetail: null,
    autoPayinCart: false,
    isCartUpdated: false,
    isMNHValueCustomer: false,
}
function profileCart(state = initialState, action) {
    switch (action.type) {
        case 'PROFILE_CART':
            if (action.value !== undefined && action.value.cartData !== undefined && action.value.cartData !== null) {
                chat.setCartChat(action.value.cartData, false);// -- Commenting off as remove product isn't working(when cartData is null). Please move this to respective action method
            }
            return Object.assign({}, state, {
                cartResponse: action.value.cartResponse,
                cartHeader: action.value.cartHeader,
                cartData: action.value.cartData,
                cartOrderDetail: action.value.cartOrderDetail
            })

        case CartActions.toggleProfileCart:
            return Object.assign({}, state, {
                isProfileCartOpen: !state.isProfileCartOpen
            })
        case CartActions.toggleOffers:
            if (action.value === "AutoPayToggle") {
                let autopayOffer = Object.assign({}, state.cartOfferToggle, {
                    isAutopayOffer: !state.cartOfferToggle.isAutopayOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: autopayOffer
                })
            }
            if (action.value === "SpecialOfferToggle") {
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOffer: !state.cartOfferToggle.isSpecialOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: specialOffer
                })
            }
            if (action.value === "SpecialOfferOneTimeToggles") {
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOneTimeOffer: !state.cartOfferToggle.isSpecialOneTimeOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: specialOffer
                })
            }
            break;
        case "EMPTYCARTSTATE":
            return initialState
        case CartActions.splitBillTab:
            return Object.assign({}, state, {
                splitBillTab: action.value
            })
        case CartActions.clearcartstate:
            return initialState
        case 'AUTOPAYINCART':
            return Object.assign({}, state, {
                autoPayinCart: action.value
            })
        case 'ISCARTUPDATED':
            return Object.assign({}, state, {
                isCartUpdated: action.value
            })
        case "ISMNHVALUECUSTOMER":
            return Object.assign({}, state, {
                isMNHValueCustomer: action.value,
            });
        default:
            return state
    }
}


export default profileCart
